/**
 * Stripe.js loader for the vault app.
 *
 * Only used for **Stripe Identity** (trustee KYC), not payments — the vault app
 * never takes card details. `verifyIdentity(clientSecret)` opens Stripe's hosted
 * document + selfie modal; the outcome is delivered server-side via the
 * `identity.verification_session.*` webhook, so the browser never self-reports a
 * result. See `docs/TRUSTEE_IDENTITY_VERIFICATION.md`.
 */
import { loadStripe, type Stripe } from "@stripe/stripe-js";

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Lazily load Stripe.js with the publishable key. Returns `null` if the key is
 * not configured so callers can degrade gracefully rather than throw.
 */
export function getStripe(): Promise<Stripe | null> | null {
  const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;
  if (!key) return null;
  stripePromise ??= loadStripe(key);
  return stripePromise;
}
